import React from 'react'

export default class TextAreaCharCount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentText: undefined,
            currentLength: 0,
        }
    }

    onChange = (event) => {
        this.setState({
            currentText: event.target.value,
            currentLength: event.target.value.length,
        })
        this.props.onChange(event.target.value)
    }

    render() {
        return (
            <div className="stand-alone-textarea-container">
                <textarea
                    className="form-control stand-alone-text-area"
                    rows={this.props.rows}
                    placeholder={this.props.placeholder}
                    maxLength={this.props.maxLength}
                    defaultValue={this.props.text}
                    onChange={this.onChange}></textarea>

                <p className="text-muted">
                    <small>
                        {' '}
                        {this.state.currentLength} / {this.props.maxLength}
                    </small>
                </p>
            </div>
        )
    }
}
